import PerformanceArtistsContainer from './PerfomanceArtists.container'

export default PerformanceArtistsContainer